import React from "react";
import { Badge } from "@amzn/awsui-components-react";
import { Investigation } from "../../lusca-search-api/generated-src";
import { redriveHistory } from "./investigationUtils";

/**
 * "1 redrive attempted" beside the status chip for a case that is back on the investigative
 * side of the path after a redrive. Nothing while the redrive step itself is current, or once
 * the case is resolved — those states already say what happened.
 */
export const RedriveAttemptedBadge: React.FC<{
  investigation: Pick<
    Investigation,
    "status" | "redriveAttemptCount" | "latestRedrive" | "returnedCount"
  >;
}> = ({ investigation }) => {
  const history = redriveHistory(investigation);
  if (!history) return null;
  const noun = history.kind === "DELETE" ? "deletion" : "redrive";
  return (
    <Badge color="grey" data-testid="redrive-attempted">
      {history.attempts} {noun}
      {history.attempts === 1 ? "" : "s"} attempted
    </Badge>
  );
};
